import axios from 'axios';
import store from '@/state/store.js';

export function fetchMenus() {
  window.menuDataReady = false;
  const url = `${process.env.VUE_APP_AUTHDOMAIN}/api/v1/me/menu`;
  return axios
    .get(url)
    .then((response) => {
      if (response.data.data) {
        store.commit('setMenus', response.data.data);
        localStorage.setItem('menuVersion', response.data.version);
      }
    })
    .catch((error) => {
      console.error('Error fetching menu:', error);
      return null;
    })
    .finally(() => {
      window.menuDataReady = true;
      window.dispatchEvent(new CustomEvent('app:menus-ready'));
    });
}
